import { Box, styled } from '@mui/material';

export const TableWrapper = styled(Box)`
  .MuiTableCell-head {
    font-weight: 700 !important;
  }
`;
